import { createRoute, useEntityUrl } from 'framework/routing';
import { OPPORTUNITY_PATH } from 'domain/shared/core/sharedRouteConstants';

export const useOpportunityRoute = () => {
  const routes = createRoute({ listRoute: OPPORTUNITY_PATH, timelinePostfix: 'activities' });

  return {
    ...routes,
    presaleTimelineRoute: `${routes.singleEntityRoute}/presale-timeline/:timelineEntryId?`,
  };
};

export const useOpportunityUrl = () => {
  const baseUrls = useEntityUrl({
    baseLink: OPPORTUNITY_PATH,
    timelinePostfix: 'activities',
  });

  return {
    ...baseUrls,
    getCreateUrl: (params?: Dictionary<string>) => {
      const urlParameters = new URLSearchParams(params).toString();

      return `${baseUrls.getCreateUrl()}${urlParameters ? `?${urlParameters}` : ''}`;
    },
  };
};
